import config from 'config'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { commonActions } from 'srcReact/components'

const UpgradeConfirmationPopin = (props) => {
  const { t, selectedPlan, subscriptionPlan, updatePlan } = props

  const handleClosePopin = () => {
    const { closePopin } = props

    closePopin()
  }

  const isLoading = () => {
    if (subscriptionPlan && subscriptionPlan.loading) {
      return true
    }
    return false
  }

  const onClick = () => {
    if (selectedPlan.with_redirection === 1) {
      window.location = selectedPlan.redirection_url
    } else {
      !isLoading() && updatePlan()
    }
  }

  const updateButtonLong = selectedPlan.update_button_message.length > 30
  return (
    <Fragment>
      <div className='popin-content--image'>
        <img src={`${config.assetUrl}/images/ready-to-upgrade.svg`} alt='process' />
      </div>
      <h2 className='popin-content--title popin-content--title-down'>{t('billing.popin.upgradeConfirmation.title')}</h2>
      <p className='popin-content--text'>{t('billing.popin.upgradeConfirmation.text')}</p>
      {selectedPlan.with_redirection === 1 && (
        <p className='popin-content--text' dangerouslySetInnerHTML={{ __html: selectedPlan.redirection_message }} />
      )}
      {
        updateButtonLong ?
          <div className='popin-content--controllers with-link'>
            <button
              type='button'
              className='button is-secondary popin-content--secondary-button'
              onClick={() => handleClosePopin()}>
              {t('billing.popin.upgradeConfirmation.btnSecondary')}
            </button>
            <button type='button' className='button is-primary popin-content--long-button popin-content--title-down' onClick={onClick} >
              {isLoading() ? t('billing.popin.upgradeConfirmation.loading') : selectedPlan.update_button_message}
            </button>
          </div>
          :
          <div className='popin-content--controllers'>
            <button
              type='button'
              className='button is-secondary popin-content--secondary-button'
              onClick={() => handleClosePopin()}>
              {t('billing.popin.upgradeConfirmation.btnSecondary')}
            </button>
            <button type='button' className='button is-primary popin-content--long-button' onClick={onClick}>
              {isLoading() ? t('billing.popin.upgradeConfirmation.loading') : selectedPlan.update_button_message}
            </button>
          </div>


      }
    </Fragment>
  )
}

function mapStateToProps(state) {
  const { subscriptionPlan } = state.subscription

  return { subscriptionPlan }
}

const actionCreators = {
  closePopin: commonActions.closePopin,
}

const ExtendedComponent = withTranslation('common')(UpgradeConfirmationPopin)
const connectedUpgradeConfirmationPopin = connect(mapStateToProps, actionCreators)(ExtendedComponent)

export { connectedUpgradeConfirmationPopin as UpgradeConfirmationPopin }
